module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-25-60a59d348be79c5f6ec8c4b5def5995f.png";